// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.full-height {\r\n  position: relative;\r\n  height: 100%;\n}\n.el-dialog__body {\r\n  padding-top: 0px;\n}\n.currency-select .el-tag.el-tag--info {\r\n  background-color: green !important;\r\n  border-color: black !important;\r\n  color: white !important;\r\n  font-size: 17px !important;\r\n  height: 30px !important;\n}\r\n", ""]);
// Exports
module.exports = exports;
